<template>
  <div class="review-box">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>买家信息</span>
      </div>
      <div class="text item">
        <ul>
          <li class="mgb15">账号ID/微信名称：{{detailData.afterSaleName}}</li>
          <li class="mgb15">手机号码：{{detailData.afterSaleMobile}}</li>
          <li class="mgb15">商品名称：{{orderDetail.orderItems[0].productSkuName}}</li>
          <li class="mgb15">子订单号：{{detailData.orderNo}}</li>
          <li class="mgb15">下单时间：{{orderDetail.creationTime}}</li>
         <li>换货地址：{{orderDetail.receivingName}}/{{orderDetail.receivingMobile}}/{{orderDetail.receivingProviceName}}{{orderDetail.receivingCityName}}{{orderDetail.receivingDistrictName}}{{orderDetail.receivingStreetName}}{{orderDetail.receivingAddress}}</li>
        </ul>
      </div>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>操作说明</span>
      </div>
      <div class="text item">
        <div class="mgb15">
          <span class="mgr40">类型：{{detailData.afterSaleType == 1 ? '退款': detailData.afterSaleType == 2 ? '退货' : '换货'}}</span>
          <span>当前订单状态：
            <span v-if="orderDetail.status == 0">创建订单</span>
            <span v-if="orderDetail.status == 1">支付成功</span>
            <span v-if="orderDetail.status == 2">待发货</span>
            <span v-if="orderDetail.status == 3">已发货</span>
            <span v-if="orderDetail.status == 4">订单完成</span>
          </span>
        </div>
        <div class="mgb15">
          <span class="mgr40">需换货数量：{{detailData.afterSaleQuantity}}</span>
          <span>需退款金额：￥{{detailData.afterSaleAmount}}</span>
        </div>
        <!-- 换货 -->
       <div class="mgb15">
         <el-table border :data="orderList" @selection-change="selectCurrentRow">
           <el-table-column type="selection" width="50" align="center"></el-table-column>
           <el-table-column label="供应商名称" prop="productSupplierName" align="center" min-width="200"></el-table-column>
           <el-table-column label="采购数量" prop="purchaseQuantity" align="center" width="140"></el-table-column>
           <el-table-column label="发货数量" prop="shipmentQuantity" align="center" width="140"></el-table-column>
           <el-table-column label="换货数量" align="center" width="200">
             <template slot-scope="scope">
               <el-input v-model.number="scope.row.afterSaleQuantity"></el-input>
             </template>
           </el-table-column>
           <el-table-column label="更换供应商发货" align="center" width="260">
             <template slot-scope="scope">
               <div style="display:flex;align-items: center;">
                <el-checkbox style="margin-right:10px;" v-model="scope.row.isReplaceSupllier" @change="(val) => changeFun(val,scope.$index, scope.row)"></el-checkbox>
                <el-autocomplete
                  v-model="scope.row.supllierName"
                  :fetch-suggestions="querySearchAsync"
                  placeholder="请选择供应商 可搜索"
                  @select="((val) => {handleSelect1(val,scope.$index, scope.row)})"
                ></el-autocomplete>
               </div>
            </template>
           </el-table-column>
         </el-table>
       </div>
        <div style="padding-top:10px;">
          <div style="margin-bottom:10px;">备注</div>
          <el-input v-model="remark" :autosize="{ minRows: 2}" type="textarea"></el-input>
        </div>
      </div>
    </el-card>
    <div class="btn-box">
      <el-button @click="save" type="primary">确认</el-button>
    </div>
  </div>
</template>

<script>
import {
  SupplierGetAll,
  OrderAfterSaleGet,
  OrderPurchaseGet,
  OrderAfterSaleConfirm
} from '../../../api/api'
export default {
  data() {
    return {
      id: null,
      orderId: null,
      detailData: {},
      orderDetail: {},
      orderList: [],
      remark: '',
      checkedList: [],
    }
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.orderId = this.$route.query.orderid
      this.getDetail(this.$route.query.id)
      this.getOrderDetail()
    } else {
      return this.$message.error('缺少售后单Id,参数缺失')
    }
  },
  methods: {
    changeFun(val, index, row) {
      // console.log(val, index, row)
      // this.$set(this.orderList[index], 'isReplaceSupllier', !val);
    },
    selectCurrentRow(arr) {
      this.checkedList = arr
    },
    save() {
      if (!this.checkedList[0]) {
        return this.$message.error('请选择操作项！')
      }
      let list = []
      this.checkedList.forEach(item => {
        list.push({
          supllierId: item.isReplaceSupllier ? item.supllierId : item.productSupplierId,
          supllierName: item.isReplaceSupllier ? item.supllierName : item.productSupplierName,
          isReplaceSupllier: item.isReplaceSupllier,
          afterSaleQuantity: item.afterSaleQuantity
        })
      });
      this.$confirm("确认提交保存吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(async () => {
        let params = {};
        params.afterSaleRemark = this.remark;
        params.orderAfterSaleId = this.detailData.id;
        params.afterSaleDetails = list
        let res = await OrderAfterSaleConfirm(params);
        if (res.data.success) {
          this.$message.success(res.data.msg || '保存成功');
        } else {
          this.$message.error(res.data.error.message || '保存失败, 请重试');
        }
      }).catch(() => {
      });
    },
    async getDetail(params) {
      let res = await OrderAfterSaleGet({id: this.id})
      if (res.data.success) {
        this.detailData = res.data.result || {}
      } else {
        this.$message.error(res.data.error || '获取失败,请重试')
      }
    },
    getOrderDetail() {
      OrderPurchaseGet({id: this.orderId}).then(res => {
        if (res.data.success) {
          this.orderDetail = res.data.result || {}
          this.orderList = res.data.result.orderPurchases || []
          this.orderList.forEach(item => {
            item.supllierId = null
            item.supllierName = null
          })
        } else {
          this.$message.error(res.data.error.message);
        }
      })
    },
    async getSupList(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100,
      };
      if (key) {
        obj.supplierName = key;
      }
      return new Promise((resolve, reject) => {
        SupplierGetAll(obj).then((res) => {
          console.log('供应商列表', res);
          if (res.data.success) {
            this.brandList = res.data.result.items.map((item) => {
              return {
                value: item.proSupplierName,
                id: item.id,
              };
            });
            resolve(this.brandList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    async querySearchAsync(queryString, cb) {
      if (queryString) {
        let res = await this.getSupList(queryString);
        cb(res);
      } else {
        let res = await this.getSupList();
        cb(res);
      }
    },
    handleSelect1(item, index, row) {
      console.log('item, index', item, index)
      // console.log('item', item);
      // this.searchData.brandId = item.id;
      this.$set(this.orderList[index], 'supllierId', item.id);
      this.$set(this.orderList[index], 'supplierName', item.value);
      console.log('this.orderList[index]', this.orderList[index]);
    },
  }
}
</script>

<style scoped>
.review-box{
  padding: 0 20px;
}
.box-card{
  margin-bottom: 20px;
}
.clearfix{
  font-size: 16px;
  font-weight: 700;
}
.mgb15{
  margin-bottom: 15px;
}
.mgr40{
  margin-right: 40px;
}
.total-box{
  margin-top: 15px;
  text-align: right;
}
.btn-box{
  text-align: center;
  margin-top: 20px;
}
</style>
